module.exports = __webpack_public_path__ + "static/img/policy@2x.d83861bc.png";